export var WorkspaceDisplayMode;
(function (WorkspaceDisplayMode) {
    WorkspaceDisplayMode["Scenario"] = "scenario";
    WorkspaceDisplayMode["Results"] = "results";
    WorkspaceDisplayMode["Calculations"] = "calculations";
})(WorkspaceDisplayMode || (WorkspaceDisplayMode = {}));
// Scenario
export var ScenarioNodeType;
(function (ScenarioNodeType) {
    ScenarioNodeType["CELLMODEL"] = "cellModel";
    ScenarioNodeType["RECIPE"] = "recipe";
    ScenarioNodeType["SIMULATION"] = "simulation";
    ScenarioNodeType["INSIGHT"] = "insight";
    ScenarioNodeType["OPTIMIZATION"] = "optimization";
    ScenarioNodeType["PROCESS_DATA"] = "processData";
})(ScenarioNodeType || (ScenarioNodeType = {}));
export var ResultSetElementType;
(function (ResultSetElementType) {
    ResultSetElementType["Unknown"] = "Unknown";
    ResultSetElementType["Table"] = "Table";
    ResultSetElementType["LineGraph"] = "LineGraph";
    ResultSetElementType["SpaceViewer"] = "SpaceViewer";
    ResultSetElementType["ProcessDataViewer"] = "ProcessDataViewer";
})(ResultSetElementType || (ResultSetElementType = {}));
export var ResultElementSourceAppearance;
(function (ResultElementSourceAppearance) {
    ResultElementSourceAppearance["Incomplete"] = "Incomplete";
    ResultElementSourceAppearance["Ready"] = "Ready";
    ResultElementSourceAppearance["InProgress"] = "InProgress";
    ResultElementSourceAppearance["Paused"] = "Paused";
    ResultElementSourceAppearance["Calculated"] = "Calculated";
    ResultElementSourceAppearance["Error"] = "Error";
})(ResultElementSourceAppearance || (ResultElementSourceAppearance = {}));
export var SimulationRunState;
(function (SimulationRunState) {
    SimulationRunState["UNKNOWN"] = "Unknown";
    SimulationRunState["CREATED"] = "Created";
    SimulationRunState["STARTED"] = "Started";
    SimulationRunState["PAUSED"] = "Paused";
    SimulationRunState["FINISHED"] = "Finished";
    SimulationRunState["CANCELED"] = "Canceled";
    SimulationRunState["ERROR"] = "Error";
    SimulationRunState["MISSED"] = "Missed";
})(SimulationRunState || (SimulationRunState = {}));
export const calculationFinishedStates = [
    SimulationRunState.FINISHED,
    SimulationRunState.CANCELED,
    SimulationRunState.ERROR,
    SimulationRunState.PAUSED,
    SimulationRunState.MISSED,
];
export var ResultElementSourceType;
(function (ResultElementSourceType) {
    ResultElementSourceType["ProcessData"] = "ProcessData";
    ResultElementSourceType["Simulation"] = "Simulation";
    ResultElementSourceType["Insight"] = "Insight";
})(ResultElementSourceType || (ResultElementSourceType = {}));
export var ResultElementGraphViewType;
(function (ResultElementGraphViewType) {
    ResultElementGraphViewType["Unknown"] = "Unknown";
    ResultElementGraphViewType["MedianWithSpread"] = "MedianWithSpread";
    ResultElementGraphViewType["Median"] = "Median";
    ResultElementGraphViewType["MeanWithSpread"] = "MeanWithSpread";
})(ResultElementGraphViewType || (ResultElementGraphViewType = {}));
export var ResultElementLineType;
(function (ResultElementLineType) {
    ResultElementLineType["Unknown"] = "Unknown";
})(ResultElementLineType || (ResultElementLineType = {}));
export var ResultElementParameterType;
(function (ResultElementParameterType) {
    ResultElementParameterType["RECIPE"] = "Recipe";
    ResultElementParameterType["CELL_MODEL"] = "CellModel";
    ResultElementParameterType["INSIGHT"] = "Insight";
    ResultElementParameterType["PROCESS_VARIABLE"] = "ProcessVariable";
    ResultElementParameterType["ALTERNATIVE_FLOW"] = "AlternativeFlow";
})(ResultElementParameterType || (ResultElementParameterType = {}));
export var TableCellResultType;
(function (TableCellResultType) {
    TableCellResultType["SINGLE_WHISKER_BAR"] = "SingleWhiskerBar";
    TableCellResultType["STATIC"] = "Static";
})(TableCellResultType || (TableCellResultType = {}));
export var CellState;
(function (CellState) {
    CellState["UNKNOWN"] = "Unknown";
    CellState["ERROR"] = "Error";
    CellState["NA"] = "NA";
    CellState["MISSING"] = "Missing";
    CellState["VALUE"] = "Value";
})(CellState || (CellState = {}));
export var TableElementSourceType;
(function (TableElementSourceType) {
    TableElementSourceType["SIMULATION"] = "Simulation";
    TableElementSourceType["PROCESS_DATA"] = "ProcessData";
})(TableElementSourceType || (TableElementSourceType = {}));
export var TableElementColumnViewType;
(function (TableElementColumnViewType) {
    TableElementColumnViewType["MOST_LIKELY"] = "MostLikely";
    TableElementColumnViewType["AVERAGE"] = "Average";
    TableElementColumnViewType["OPTIMISTIC"] = "Optimistic";
    TableElementColumnViewType["PESSIMISTIC"] = "Pessimistic";
    TableElementColumnViewType["SPREAD"] = "Spread";
})(TableElementColumnViewType || (TableElementColumnViewType = {}));
export var ProcessVariableType;
(function (ProcessVariableType) {
    ProcessVariableType["CellModel"] = "CellModel";
    ProcessVariableType["Recipe"] = "Recipe";
    ProcessVariableType["Custom"] = "Custom";
})(ProcessVariableType || (ProcessVariableType = {}));
export var ProcessDataEntityTarget;
(function (ProcessDataEntityTarget) {
    ProcessDataEntityTarget["ProcessVariable"] = "ProcessVariable";
    ProcessDataEntityTarget["CumulativeLiquid"] = "CumulativeLiquid";
})(ProcessDataEntityTarget || (ProcessDataEntityTarget = {}));
export var ProcessDataViewerSourceVariableType;
(function (ProcessDataViewerSourceVariableType) {
    ProcessDataViewerSourceVariableType["ProcessVariable"] = "ProcessVariable";
    ProcessDataViewerSourceVariableType["Custom"] = "Custom";
    ProcessDataViewerSourceVariableType["Liquid"] = "Liquid";
})(ProcessDataViewerSourceVariableType || (ProcessDataViewerSourceVariableType = {}));
//Optimization
export var OptimizationTargetType;
(function (OptimizationTargetType) {
    OptimizationTargetType["RECIPE"] = "Recipe";
    OptimizationTargetType["CELL_MODEL"] = "CellModel";
})(OptimizationTargetType || (OptimizationTargetType = {}));
export var OptimizationParameterParameterType;
(function (OptimizationParameterParameterType) {
    OptimizationParameterParameterType["CELL_MODEL_OR_RECIPE"] = "CellModelOrRecipe";
    OptimizationParameterParameterType["ALTERNATIVE_FLOW"] = "AlternativeFlow";
})(OptimizationParameterParameterType || (OptimizationParameterParameterType = {}));
// Insight
export var InsightInputType;
(function (InsightInputType) {
    InsightInputType["SIMULATION"] = "Simulation";
    InsightInputType["PROCESS_DATA"] = "ProcessData";
})(InsightInputType || (InsightInputType = {}));
export var InsightOutputTypes;
(function (InsightOutputTypes) {
    InsightOutputTypes["Comparison"] = "Comparison";
    InsightOutputTypes["Evaluation"] = "Evaluation";
})(InsightOutputTypes || (InsightOutputTypes = {}));
export var InsightOutputVariableTypes;
(function (InsightOutputVariableTypes) {
    InsightOutputVariableTypes["CellModel"] = "CellModel";
    InsightOutputVariableTypes["Recipe"] = "Recipe";
    InsightOutputVariableTypes["Custom"] = "Custom";
})(InsightOutputVariableTypes || (InsightOutputVariableTypes = {}));
export var InsightCutOperations;
(function (InsightCutOperations) {
    InsightCutOperations["Trim"] = "Trim";
    InsightCutOperations["Stretch"] = "Stretch";
})(InsightCutOperations || (InsightCutOperations = {}));
export var InsightPreProcessingTypes;
(function (InsightPreProcessingTypes) {
    InsightPreProcessingTypes["Absolute"] = "Absolute";
    InsightPreProcessingTypes["Ratio"] = "Ratio";
})(InsightPreProcessingTypes || (InsightPreProcessingTypes = {}));
export var OutputWeight;
(function (OutputWeight) {
    OutputWeight["Unset"] = "Unset";
    OutputWeight["Low"] = "Low";
    OutputWeight["Normal"] = "Normal";
    OutputWeight["High"] = "High";
    OutputWeight["VeryHigh"] = "VeryHigh";
    OutputWeight["Essential"] = "Essential";
})(OutputWeight || (OutputWeight = {}));
export var InsightScoreErrorType;
(function (InsightScoreErrorType) {
    InsightScoreErrorType["SIMULATION_VARIABLE_NOT_FOUND"] = "SimulationVariableNotFound";
    InsightScoreErrorType["PROCESS_DATA_VARIABLE_NOT_FOUND"] = "ProcessDataVariableNotFound";
    InsightScoreErrorType["INTERNAL"] = "Internal";
    InsightScoreErrorType["VALIDATION"] = "Validation";
    InsightScoreErrorType["SIMULATION_EVENT_NOT_FOUND"] = "SimulationEventNotFound";
})(InsightScoreErrorType || (InsightScoreErrorType = {}));
export var RunsCount;
(function (RunsCount) {
    RunsCount["None"] = "None";
    RunsCount["Low"] = "Low";
    RunsCount["Tech3"] = "Test";
    RunsCount["Medium"] = "Medium";
    RunsCount["High"] = "High";
})(RunsCount || (RunsCount = {}));
export var Accuracy;
(function (Accuracy) {
    Accuracy["NONE"] = "None";
    Accuracy["LOW"] = "Low";
    Accuracy["MEDIUM"] = "Medium";
    Accuracy["HIGH"] = "High";
    Accuracy["VERY_HIGH"] = "Very High";
})(Accuracy || (Accuracy = {}));
export var CalculationRowField;
(function (CalculationRowField) {
    CalculationRowField["uncertainty"] = "uncertainty";
    CalculationRowField["variability"] = "variability";
    CalculationRowField["numberOfOptimisationSteps"] = "numberOfOptimisationSteps";
})(CalculationRowField || (CalculationRowField = {}));
export const runsCountValue = {
    [RunsCount.None]: 1,
    [RunsCount.Tech3]: 3,
    [RunsCount.Low]: 25,
    [RunsCount.Medium]: 50,
    [RunsCount.High]: 100,
};
export var CalculationElementSourceType;
(function (CalculationElementSourceType) {
    CalculationElementSourceType["Simulation"] = "Simulation";
    CalculationElementSourceType["Insight"] = "Insight";
    CalculationElementSourceType["ProcessData"] = "ProcessData";
    CalculationElementSourceType["Optimization"] = "Optimization";
})(CalculationElementSourceType || (CalculationElementSourceType = {}));
export var CalculationStatusSource;
(function (CalculationStatusSource) {
    CalculationStatusSource["New"] = "New";
    CalculationStatusSource["InProgress"] = "InProgress";
    CalculationStatusSource["Completed"] = "Completed";
    CalculationStatusSource["Paused"] = "Paused";
    CalculationStatusSource["Canceled"] = "Canceled";
    CalculationStatusSource["Error"] = "Error";
    CalculationStatusSource["Incomplete"] = "Incomplete";
})(CalculationStatusSource || (CalculationStatusSource = {}));
export var CalculationStatus;
(function (CalculationStatus) {
    CalculationStatus["New"] = "New";
    CalculationStatus["InProgress"] = "InProgress";
    CalculationStatus["Incomplete"] = "Incomplete";
    CalculationStatus["Paused"] = "Paused";
})(CalculationStatus || (CalculationStatus = {}));
export var CancelOutdatedPreviewType;
(function (CancelOutdatedPreviewType) {
    CancelOutdatedPreviewType[CancelOutdatedPreviewType["Unknown"] = 0] = "Unknown";
    CancelOutdatedPreviewType[CancelOutdatedPreviewType["Simulation"] = 1] = "Simulation";
    CancelOutdatedPreviewType[CancelOutdatedPreviewType["Insight"] = 2] = "Insight";
    CancelOutdatedPreviewType[CancelOutdatedPreviewType["Optimization"] = 3] = "Optimization";
})(CancelOutdatedPreviewType || (CancelOutdatedPreviewType = {}));
export var EntitiesCreatableFromResultElement;
(function (EntitiesCreatableFromResultElement) {
    EntitiesCreatableFromResultElement["Recipe"] = "Recipe";
    EntitiesCreatableFromResultElement["CellModel"] = "CellModel";
    EntitiesCreatableFromResultElement["Variant"] = "Variant";
})(EntitiesCreatableFromResultElement || (EntitiesCreatableFromResultElement = {}));
